/**
 * Covenant accordion topics (Coming Soon page).
 *
 * Labels live in messages (`pages.home.cs.covenant.items.<labelKey>`).
 * Open-panel copy lives per topic under `pages.home.cs.covenant.panels.<labelKey>`.
 */
export interface CovenantTopic {
  id: string;
  index: number;
  labelKey: string;
  /** Optional scoring-strategy bullets (`panels.<labelKey>.pointN`). */
  points?: readonly string[];
  /** Optional roll-up line (`panels.<labelKey>.chain`). */
  chain?: boolean;
}

export const COVENANT_TOPICS: readonly CovenantTopic[] = [
  {
    id: 'scoring-strategy',
    index: 1,
    labelKey: 'scoringStrategy',
    points: ['point1', 'point2', 'point3', 'point4', 'point5'],
  },
  { id: 'how-it-works', index: 2, labelKey: 'howItWorks', chain: true },
  { id: 'scoring-caps', index: 3, labelKey: 'scoringCaps' },
  { id: 'war-orders', index: 4, labelKey: 'warOrders' },
  { id: 'manual-verification', index: 5, labelKey: 'manualVerification' },
  { id: 'fair-play', index: 6, labelKey: 'fairPlay' },
  { id: 'community-conduct', index: 7, labelKey: 'communityConduct' },
];
